import React from "react";
import { Zap, ArrowRight, Play, Bell } from "lucide-react";
import heroPhoto from "../../../assets/portal/hero-caregiver.jpg";
import { Pill, HeroStat } from "../components/helpers";
import { NIGHT, MINT, TEXT_INK, TEXT_DARK, TEXT_DIM, TEXT_DIM_ON_DARK, BORDER_ON_DARK, FONT_STACK, CONTAINER, ORANGE } from "../tokens";

export default function Hero() {
  return (
    <section style={{ background: NIGHT, padding: "60px 0 100px", position: "relative", overflow: "hidden", color: "#FFFFFF" }}>
      <div style={{ ...CONTAINER, display: "grid", gridTemplateColumns: "1.05fr 0.95fr", gap: 56, alignItems: "center" }}>
        <div>
          <Pill icon={Zap} dark>Hours that fill themselves in</Pill>
          <h1 style={{ fontSize: "clamp(40px, 5vw, 60px)", fontWeight: 800, color: "#FFFFFF", lineHeight: 1.05, letterSpacing: "-0.025em", margin: "20px 0 22px" }}>
            Your team's hours, <span style={{ color: MINT }}>filled in automatically.</span>
          </h1>
          <p style={{ fontSize: 17, lineHeight: 1.55, color: "rgba(240, 250, 248, 0.75)", margin: "0 0 28px", maxWidth: 540 }}>
            Your team clocks in and out, and the hours fill themselves into payroll. Novala even reminds anyone who leaves still clocked in, so the numbers stay right. You review, approve, and pay.
          </p>
          <div style={{ display: "flex", gap: 14, alignItems: "center", marginBottom: 36 }}>
            <button style={{ background: MINT, color: NIGHT, fontSize: 15, fontWeight: 700, padding: "13px 22px", border: "none", borderRadius: 9, cursor: "pointer", fontFamily: FONT_STACK, display: "inline-flex", alignItems: "center", gap: 8 }}>
              Get started <ArrowRight size={16} />
            </button>
            <span style={{ display: "inline-flex", alignItems: "center", gap: 7, fontSize: 13.5, color: TEXT_DIM_ON_DARK, cursor: "pointer", fontWeight: 600 }}>
              <span style={{ width: 30, height: 30, borderRadius: "50%", background: "rgba(255,255,255,0.08)", display: "grid", placeItems: "center" }}>
                <Play size={11} fill="#FFFFFF" color="#FFFFFF" />
              </span>
              See how it works
            </span>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 24, borderTop: "0.5px solid " + BORDER_ON_DARK, paddingTop: 24 }}>
            <HeroStat top="1 invite" bottom="Team self setup" />
            <HeroStat top="Automatic" bottom="Hours into payroll" />
            <HeroStat top="Smart" bottom="Clock-out reminders" />
          </div>
        </div>
        <div style={{ position: "relative" }}>
          <div style={{ position: "absolute", inset: -20, background: "radial-gradient(circle, rgba(47, 227, 190, 0.18) 0%, transparent 70%)", filter: "blur(20px)" }} />
          <div style={{ position: "relative", borderRadius: 20, overflow: "hidden" }}>
            <img src={heroPhoto} alt="A caregiver checking their phone" style={{ width: "100%", height: "auto", display: "block" }} />
          </div>
          <div style={{ position: "absolute", top: 70, left: -36, background: "#FFFFFF", color: TEXT_INK, padding: "12px 14px", borderRadius: 12, boxShadow: "0 16px 30px rgba(0,0,0,0.18)", display: "flex", alignItems: "flex-start", gap: 10, maxWidth: 230, fontSize: 12.5, fontWeight: 600, lineHeight: 1.4 }}>
            <span style={{ width: 28, height: 28, borderRadius: "50%", background: "rgba(242, 153, 74, 0.16)", display: "grid", placeItems: "center", flexShrink: 0 }}>
              <Bell size={14} color={ORANGE} />
            </span>
            <span>
              <div style={{ color: TEXT_DARK, fontSize: 10, fontWeight: 700, letterSpacing: "0.04em", textTransform: "uppercase" }}>Reminder</div>
              You left while clocked in
            </span>
          </div>
          <div style={{ position: "absolute", bottom: 48, right: -28, background: "#FFFFFF", color: TEXT_INK, padding: "14px 16px", borderRadius: 14, boxShadow: "0 16px 30px rgba(0,0,0,0.18)", minWidth: 230 }}>
            <div style={{ fontSize: 10, color: TEXT_DIM, fontWeight: 700, letterSpacing: "0.04em", textTransform: "uppercase" }}>Net pay this period</div>
            <div style={{ fontSize: 22, fontWeight: 800, color: TEXT_INK, marginTop: 4, fontVariantNumeric: "tabular-nums" }}>$1,853.73</div>
            <div style={{ display: "flex", gap: 16, fontSize: 11, color: TEXT_DARK, marginTop: 7, fontWeight: 600 }}>
              <span>74.0 hrs</span>
              <span>Paid Jun 13</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}